let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1nJsT")).then(() => parcelRequire('py0DQ'));